module.exports = __webpack_public_path__ + "static/time-management-image-1ce1fba1c9125af635ec05ec35866ebc.svg";